Ext.define('SA.view.menu.MenuVisibilityTracker', {
    singleton: true,

    menus: [],
    visibleMenus: [],

    onDocClick() {
        Ext.EventManager.idleEvent.addListener(this.onIdleEvent, this, {single: true});
    },

    onDocMouseDown() {
        var visibleMenus = this.visibleMenus,
            menus = this.menus,
            index = menus.length - 1,
            menu;

        visibleMenus.length = 0;

        for ( ; index >= 0 ; --index) {
            menu = menus[index];

            if (menu.isDestroyed) {
                menus.splice(index, 1);
            }
            else if (menu.isVisible()) {
                visibleMenus.push(menu);
            }
        }

        if (visibleMenus.length) {
            Ext.getDoc().on('click', this.onDocClick, this, {single: true});
        }
    },

    onIdleEvent() {
        this.visibleMenus.length = 0;
    },

    track(menu) {
        this.menus.push(menu);
    },

    wasRecentlyVisible(menu) {
        return menu.isVisible() || this.visibleMenus.includes(menu);
    }
}, function(manager) {
    Ext.onReady(() => {
        Ext.getDoc().on('mousedown', manager.onDocMouseDown, manager);
    });
});